import { type BuildDetailsFieldsParams, field, typedField, withLayout } from '../fieldHelpers';
import type { DetailField } from '../types';

export function buildPartnershipGoalsFields({ opportunity }: BuildDetailsFieldsParams): Array<DetailField> {
  const partnershipGoals = opportunity?.partnership_goals;

  return [
    typedField(
      'Room Night Target',
      undefined,
      'number',
      'Room night target communicated to the hotel as a minimum production.',
      { columns: 2 },
    ),
    withLayout(field('Primary Market', undefined), { columns: 2 }),
    withLayout(field('Hotel Goals', partnershipGoals?.usp__c, 'What problem are we solving for the hotel.', true), {
      columns: 2,
      span: 'full',
    }),
  ];
}
